import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import {
  Dropdown,
  Form,
  OverlayTrigger,
  Popover,
  Button,
} from "react-bootstrap"; // Import Button
import Select from "react-select";
import { supabase } from "../../supabaseClient";
import moment from "moment"; // Import moment
import { DateFormtter } from "../../utils/index";
import ConfirmationPopup from "../common/ConfirmationPopup"; // Import ConfirmationPopup
import EditPopup from "../common/EditPopup"; // Import EditPopup
import AddTaskPopUp from "../common/AddTaskPopup";
import NotesExpandMoreopup from "../common/NotesExpandMoreopup";
import NotesExpandAllPopup from "../common/NotesExpandAllPopup";
import DeleteCategoryPopUp from "../common/DeleteCategory";
import PortalDropdown from "../common/PortalDropdown";
import QuickSharePopup from '../common/QuickSharePopup'
import UnsharePopup from '../common/UnsharePopup'
import { TbFilterCog } from 'react-icons/tb';
import '../../assets/css/checklist.css';
const NotesList = forwardRef(
  (
    {
      isDarkMode,
      isNotesCategoryUpdate,
      isNotesDataChannelUpdate,
      isnotesProfileChannel,
      isSidebarVisible,
    },
    ref
  ) => {
    const [categoryUpdateCode, setCategoryUpdateCode] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [subcategories, setSubcategories] = useState([]);
    const [UserId, setUserId] = useState(null);
    const [tasks, setTasks] = useState([]);
    const [completedTasks, setCompletedTasks] = useState({});
    const [hasMoreTasks, setHasMoreTasks] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [allTasks, setAllTasks] = useState([]);
    const [selectedSubcategory, setSelectedSubcategory] = useState(""); // Define selectedSubcategory state
    const [taskToRemove, setTaskToRemove] = useState(null); // Add state to track task to be removed
    const [showConfirmation, setShowConfirmation] = useState(false); // Add state to manage confirmation popup visibility
    const popoverRef = useRef(null);
    const [showPopover, setShowPopover] = useState(null); // Add state to manage popover visibility
    const [taskToEdit, setTaskToEdit] = useState(null); // Add state to track task to be edited
    const [showEditPopup, setShowEditPopup] = useState(false); // Add state to manage edit popup visibility
    const [showAddPopup, setShowAddPopup] = useState(false);
    const [showExpandAll, setShowExpandAll] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [categories, setCategories] = useState([]);
    const [showExportMore, setShowExportMore] = useState(false);
    const [ShowDeleteCategory, setShowDeleteCategory] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [quickShareState, setQuickShareState] = useState(null)
    const [unshareState, setUnshareState] = useState(null)
    const notesessionScrollRef = useRef(null);
    const [showFilters, setShowFilters] = useState(false);
    const [sharedNotes, setSharedNotes] = useState([])
    const [sharedCategories, setSharedCategories] = useState([])
    const [sentNoteIds, setSentNoteIds] = useState(new Set())
    const [sentCategoryIds, setSentCategoryIds] = useState(new Set())

    // Move confirmation states
    const [showMoveConfirmation, setShowMoveConfirmation] = useState(false);
    const [itemToMove, setItemToMove] = useState(null);
    const [moveTarget, setMoveTarget] = useState(null);

    // Expose triggerShowAll function to parent
    useImperativeHandle(ref, () => ({
      triggerShowAll: () => {
        // Call Show All functionality
        fetchAllTasks(searchTerm, selectedCategory, selectedSubcategory);
        setShowExportMore(true);
      },
    }));

    const confirmMoveItem = (task, targetTable) => {
      setItemToMove(task);
      setMoveTarget(targetTable);
      setShowMoveConfirmation(true);
    };

    const moveItem = async () => {
      if (!itemToMove || !moveTarget) return;
      try {
        // 1. Insert into target table
        const { error: insertError } = await supabase
          .from(moveTarget)
          .insert([{
            title: itemToMove.title,
            description: itemToMove.description,
            status: itemToMove.status,
            user_id: UserId
          }]);

        if (insertError) throw insertError;

        // 2. Delete from current table
        const { error: deleteError } = await supabase
          .from("notes")
          .delete()
          .eq("id", itemToMove.id);

        if (deleteError) throw deleteError;

        // 3. Refresh and close confirmation
        fetchTasks(searchTerm, selectedCategory, selectedSubcategory);
        setShowMoveConfirmation(false);
        setItemToMove(null);
        setMoveTarget(null);
      } catch (error) {
        console.error("Error moving item:", error);
      }
    };

    const getMoveTargetLabel = (target) => {
      switch(target) {
        case 'tasks': return 'Tasks';
        case 'lists': return 'Lists';
        case 'grocery_table': return 'Groceries';
        default: return target;
      }
    };

    const [groupedTasks, setGroupedTasks] = useState({
      today: [],
      next7Days: [],
      next30Days: [],
      later: [],
    });
    useEffect(() => {
      fetchCategories();
      fetchSharedNotes();
      fetchSentNoteIds();
      if (categoryUpdateCode !== null) {
        fetchSubcategories(categoryUpdateCode);
      }
    }, [isNotesCategoryUpdate]);
    useEffect(() => {
      fetchTasks(searchTerm, selectedCategory, selectedSubcategory);
    }, [isNotesDataChannelUpdate]);

    useEffect(() => {
      if (isnotesProfileChannel > 0) {
        setShowExportMore(true);
      }
    }, [isnotesProfileChannel]);
    const fetchTasks = useCallback(
      async (search = "", categoryId = "", subcategoryId = "") => {
        if (UserId) {
          setIsLoading(true);
          try {
            let query = supabase
              .from("notes")
              .select("id, title, description, status, category_id", {
                count: "exact",
              })
              .eq("user_id", UserId)
              .or('is_share.is.null,is_share.eq.false')
              .ilike("title", `%${search}%`)
              // .order('status', { ascending: false })
              .order("created_at", { ascending: false }) // Newly created tasks first

              // .gt('due_date', moment().startOf('day').toISOString())
              .limit(5);

            if (subcategoryId) {
              query = query.eq("category_id", subcategoryId);
            } else if (categoryId) {
              const { data: subcategories } = await supabase
                .from("notes_categories")
                .select("id")
                .eq("parent_category_id", categoryId);
              const subcategoryIds = subcategories.map((sub) => sub.id);
              query = query.in("category_id", [categoryId, ...subcategoryIds]);
            }

            const { data, error, count } = await query;
            if (error) {
              throw error;
            }
            const sorted = data.sort((a, b) => {
              // Step 1: Prioritize 'pending' before 'completed'
              if (a.status !== b.status) {
                return a.status === "pending" ? -1 : 1;
              }

              // Step 2: If both are 'pending', sort by created_at (newest first)
              if (a.status === "pending") {
                return new Date(b.created_at) - new Date(a.created_at);
              }

              // Step 3: If both are 'completed', keep original order or sort alphabetically
              return 0; // ← No further sorting for completed
            });
            setTasks(sorted);
            setHasMoreTasks(count > 5);
            const completed = {};
            data.forEach((task) => {
              completed[task.id] = task.status === "completed";
            });
            setCompletedTasks(completed);

            // Group tasks by due date
            const today = [];
            const next7Days = [];
            const next30Days = [];
            const later = [];

            data.forEach((task) => {
              const dueDate = moment(task.due_date);
              if (dueDate.isSame(moment(), "day")) {
                today.push(task);
              } else if (
                dueDate.isBetween(
                  moment(),
                  moment().add(7, "days"),
                  "day",
                  "[]"
                )
              ) {
                next7Days.push(task);
              } else if (
                dueDate.isBetween(
                  moment(),
                  moment().add(30, "days"),
                  "day",
                  "[]"
                )
              ) {
                next30Days.push(task);
              } else {
                later.push(task);
              }
            });

            setGroupedTasks({ today, next7Days, next30Days, later });
          } catch (error) {
            console.error("Error fetching tasks:", error);
          } finally {
            setIsLoading(false);
          }
        }
      },
      [UserId]
    );
    const fetchAllTasks = async (
      search = "",
      categoryId = "",
      subcategoryId = ""
    ) => {
      try {
        let query = supabase
          .from("notes")
          .select("id, title, description, status")
          .eq("user_id", UserId)
          .or('is_share.is.null,is_share.eq.false')
          .order("status", { ascending: false }) // Order by created_at in descending order
          .ilike("title", `%${search}%`);

        if (categoryId) {
          query = query.eq("category_id", categoryId);
        }

        if (subcategoryId) {
          query = query.eq("category_id", subcategoryId);
        }

        const { data, error } = await query;
        if (error) {
          throw error;
        }
        setAllTasks(data);
      } catch (error) {
        console.error("Error fetching all tasks:", error);
      }
    };
    const fetchCategories = async () => {
      try {
        if (UserId) {
          const { data, error } = await supabase
            .from("notes_categories")
            .select("id, name, is_share")
            .eq("user_id", UserId)
            .is("parent_category_id", null)
            .or('is_share.is.null,is_share.eq.false');
          if (error) {
            throw error;
          }
          setCategories(data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    const fetchSubcategories = async (categoryId) => {
      try {
        const { data, error } = await supabase
          .from("notes_categories")
          .select("id, name, is_share")
          .eq("user_id", UserId)
          .eq("parent_category_id", categoryId)
          .or('is_share.is.null,is_share.eq.false');
        if (error) {
          throw error;
        }
        setSubcategories(data);
        return data; // Return data so AddTaskPopup can use it
      } catch (error) {
        console.error("Error fetching subcategories:", error);
        return []; // Return empty array on error
      }
    };
    const fetchSharedNotes = useCallback(async () => {
      if (!UserId) return
      try {
        const { data: shared } = await supabase
          .from('notes')
          .select('id, title, description, status, category_id, shared_by, share_visible')
          .eq('user_id', UserId)
          .eq('is_share', true)
          .not('shared_by', 'is', null)
          .order('created_at', { ascending: false })

        const items = (shared || []).map(t => ({
          ...t, _shared: true, _sharedFrom: t.shared_by || 'Unknown', _isNew: t.share_visible === false
        }))
        setSharedNotes(items)

        const catIds = [...new Set(items.map(t => t.category_id).filter(id => id && id !== 0))]
        if (catIds.length > 0) {
          const { data: cats } = await supabase
            .from('notes_categories')
            .select('id, name, parent_category_id')
            .in('id', catIds)

          const seen = new Set()
          const allCatMap = {}
          ;(cats || []).forEach(c => { allCatMap[c.id] = c })

          const parentOnlyIds = (cats || []).map(c => c.parent_category_id).filter(id => id && !catIds.includes(id))
          if (parentOnlyIds.length > 0) {
            const { data: parentCats } = await supabase.from('notes_categories').select('id, name').in('id', parentOnlyIds)
            ;(parentCats || []).forEach(pc => { allCatMap[pc.id] = pc })
          }

          const finalParents = []
          ;(cats || []).forEach(cat => {
            const pid = cat.parent_category_id || cat.id
            if (!seen.has(String(pid))) {
              seen.add(String(pid))
              const name = cat.parent_category_id ? (allCatMap[cat.parent_category_id]?.name || cat.name) : cat.name
              finalParents.push({ id: `shared_${pid}`, originalId: String(pid), name: `${name} (shared)` })
            }
          })
          setSharedCategories(finalParents)
        } else {
          setSharedCategories([])
        }
      } catch (e) {
        console.error('Error fetching shared notes:', e)
      }
    }, [UserId])

    const fetchSentNoteIds = useCallback(async () => {
      if (!UserId) return
      try {
        const API_URL = process.env.REACT_APP_ZOOMEY_API_URL || 'http://localhost:3000'
        const res = await fetch(`${API_URL}/api/sharing/sent-task-ids?user_id=${UserId}&section_type=notes`)
        const data = await res.json()
        setSentNoteIds(new Set((data?.sent_task_ids || []).map(String)))
        setSentCategoryIds(new Set((data?.sent_category_ids || []).map(String)))
      } catch (e) { console.error('Error fetching sent note ids:', e) }
    }, [UserId])

    const syncSharedNote = async (noteId, updates) => {
      try {
        const API_URL = process.env.REACT_APP_ZOOMEY_API_URL || 'http://localhost:3000'
        await fetch(`${API_URL}/api/sharing/sync-task`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ task_id: noteId, user_id: UserId, updates, section_type: 'notes' }),
        })
      } catch (e) { console.error('Error syncing shared note:', e) }
    }

    const handleCategoryChange = (e) => {
      const categoryId = e.target.value;
      if (categoryId === "-1") {
        setShowDeleteCategory(true);
      }
      setCategoryUpdateCode(categoryId);
      setSelectedCategory(categoryId);
      fetchSubcategories(categoryId);
      fetchTasks(searchTerm, categoryId);
    };
    const handleSubcategoryChange = (e) => {
      const subcategoryId = e.target.value;
      setSelectedSubcategory(subcategoryId);
      fetchTasks(searchTerm, selectedCategory, subcategoryId);
    };

    const handleSearchChange = (e) => {
      const search = e.target.value;
      setSearchTerm(search);
      fetchTasks(search, selectedCategory);
    };
    const toggleTaskCompletion = async (taskId, isShared = false) => {
      if (isShared) {
        const item = sharedNotes.find(t => t.id === taskId)
        const newStatus = item?.status === 'completed' ? 'pending' : 'completed'
        try {
          const { error } = await supabase
            .from('notes')
            .update({ status: newStatus })
            .eq('id', taskId)
            .eq('user_id', UserId)
          if (error) throw error
          setSharedNotes(prev => prev.map(t => t.id === taskId ? { ...t, status: newStatus } : t))
          syncSharedNote(taskId, { status: newStatus })
        } catch (error) {
          console.error('Error updating shared note status:', error)
        }
      } else {
        const newStatus = completedTasks[taskId] ? "pending" : "completed";
        try {
          const { error } = await supabase
            .from("notes")
            .update({ status: newStatus })
            .eq("id", taskId)
            .eq("user_id", UserId);
          if (error) {
            throw error;
          }
          setCompletedTasks((prev) => ({
            ...prev,
            [taskId]: !prev[taskId],
          }));
          syncSharedNote(taskId, { status: newStatus })
        } catch (error) {
          console.error("Error updating task status:", error);
        }
      }
    };
    const confirmRemoveTask = (taskId) => {
      setTaskToRemove(taskId);
      setShowConfirmation(true);
    };
    const removeTask = async () => {
      try {
        const { error } = await supabase
          .from("notes")
          .delete()
          .eq("id", taskToRemove)
          .eq("user_id", UserId);
        if (error) {
          throw error;
        }
        setTasks((prev) => prev.filter((task) => task.id !== taskToRemove));
        setShowConfirmation(false);
        setTaskToRemove(null);
      } catch (error) {
        console.error("Error removing task:", error);
      }
    };
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setShowPopover(null);
      }
    };

    useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    const handleEditTask = (task) => {
      setTaskToEdit(task);
      setShowEditPopup(true);
    };

    const saveTask = async (updatedTask) => {
      try {
        let categoryId = updatedTask.category_id;

        // Handle new category creation
        if (updatedTask.isNewCategory && updatedTask.category_id) {
          const { data: catData, error: catError } = await supabase
            .from("notes_categories")
            .insert([{
              name: updatedTask.category_id,
              parent_category_id: null,
              user_id: UserId
            }])
            .select();

          if (catError) {
            console.error("Error creating category:", catError);
            throw catError;
          }
          categoryId = catData[0].id;

          // Handle new subcategory creation (requires new category to be created first)
          if (updatedTask.isNewSubcategory && updatedTask.subcategory_id) {
            const { data: subData, error: subError } = await supabase
              .from("notes_categories")
              .insert([{
                name: updatedTask.subcategory_id,
                parent_category_id: categoryId,
                user_id: UserId
              }])
              .select();

            if (subError) {
              console.error("Error creating subcategory:", subError);
              throw subError;
            }
            categoryId = subData[0].id;
          }
        } else if (updatedTask.isNewSubcategory && updatedTask.subcategory_id) {
          // Creating new subcategory under existing category
          const parentCategoryId = updatedTask.category_id;
          const { data: subData, error: subError } = await supabase
            .from("notes_categories")
            .insert([{
              name: updatedTask.subcategory_id,
              parent_category_id: parentCategoryId,
              user_id: UserId
            }])
            .select();

          if (subError) {
            console.error("Error creating subcategory:", subError);
            throw subError;
          }
          categoryId = subData[0].id;
        } else if (updatedTask.subcategory_id && /^\d+$/.test(updatedTask.subcategory_id)) {
          // Using existing subcategory
          categoryId = updatedTask.subcategory_id;
        }

        const updateData = {
          title: updatedTask.title,
          description: updatedTask.description
        };

        if (!updatedTask._shared && !updatedTask._sent) {
          if (categoryId && categoryId !== "0") {
            updateData.category_id = categoryId;
          }
        }

        if (updatedTask.id) {
          const { error } = await supabase
            .from("notes")
            .update(updateData)
            .eq("id", updatedTask.id)
            .eq("user_id", UserId);
          if (error) {
            throw error;
          }
          syncSharedNote(updatedTask.id, {
            title: updateData.title,
            description: updateData.description,
          })
        } else {
          const { error } = await supabase
            .from("notes")
            .insert([{ ...updateData, user_id: UserId, status: "pending" }]);
          if (error) {
            throw error;
          }
        }

        // Refresh categories if new ones were created
        if (updatedTask.isNewCategory || updatedTask.isNewSubcategory) {
          fetchCategories();
          if (selectedCategory) {
            fetchSubcategories(selectedCategory);
          }
        }

        if (updatedTask._shared) {
          setSharedNotes(prev =>
            prev.map(task => (task.id === updatedTask.id ? { ...task, ...updateData, category_id: categoryId } : task))
          )
        } else {
          setTasks((prev) =>
            prev.map((task) => (task.id === updatedTask.id ? { ...updatedTask, category_id: categoryId } : task))
          );
        }
        setShowEditPopup(false);
        setTaskToEdit(null);
      } catch (error) {
        console.error("Error updating task:", error);
      }
    };

    const handleExpandAll = () => {
      fetchAllTasks(searchTerm, selectedCategory, selectedSubcategory);
      setShowExpandAll(true);
    };

    const renderTask = (taskId, title, description, due_date, category_id, isShared = false, sharedFrom = '', isNew = false, isSent = false) => {
      const isCompleted = isShared ? (sharedNotes.find(t => t.id === taskId)?.status === 'completed') : completedTasks[taskId];

      return (
        <div
          className={`note-card ${isCompleted ? 'note-completed' : ''}`}
          key={`${isShared ? 'shared_' : ''}${taskId}`}
          data-item-id={taskId}
          onClick={e => {
            if (openDropdownId === taskId) return;
            handleEditTask({ id: taskId, title, description, due_date, category_id, _shared: isShared, _sent: isSent });
          }}
        >
          {/* Note Header Row */}
          <div className="note-card-header">
            <div
              className={`note-checkbox ${isCompleted ? 'checked' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                toggleTaskCompletion(taskId, isShared);
              }}
            >
              {isCompleted && <i className="bi bi-check"></i>}
            </div>

            <div className="note-card-content">
              <div className="d-flex align-items-center gap-1">
                <h4 className={`note-title ${isCompleted ? 'completed' : ''}`} title={title} style={{ margin: 0 }}>
                  {title}
                </h4>
                {isNew && (
                  <span style={{
                    fontSize: '0.55rem', fontWeight: 700, textTransform: 'uppercase',
                    background: 'var(--teal-bg)', color: '#fff',
                    padding: '1px 5px', borderRadius: '3px', flexShrink: 0, lineHeight: '13px',
                  }}>New</span>
                )}
              </div>
              {description && (
                <p
                  className={`note-description ${isCompleted ? 'completed' : ''}`}
                  dangerouslySetInnerHTML={{ __html: formatMessage(description) }}
                />
              )}
            </div>

            {!isShared && (
              <i
                className="bi bi-send"
                style={{ fontSize: '0.85rem', cursor: 'pointer', color: '#14b8a6', padding: '2px 4px' }}
                title="Quick Share"
                onClick={(e) => { e.stopPropagation(); setQuickShareState(quickShareState?.id === taskId ? null : { id: taskId, rect: e.currentTarget.getBoundingClientRect() }) }}
              ></i>
            )}
            {quickShareState?.id === taskId && (
              <QuickSharePopup
                show={true}
                onClose={() => setQuickShareState(null)}
                itemId={taskId}
                sectionType="notes"
                UserId={UserId}
                isDarkMode={isDarkMode}
                onShareSuccess={fetchSentNoteIds}
                anchorRect={quickShareState?.rect}
              />
            )}
            {unshareState?.id === taskId && (
              <UnsharePopup
                show={true}
                onClose={() => setUnshareState(null)}
                itemId={taskId}
                sectionType="notes"
                UserId={UserId}
                isDarkMode={isDarkMode}
                onUnshareSuccess={() => { fetchSentNoteIds(); fetchTasks(searchTerm, selectedCategory, selectedSubcategory); }}
                anchorRect={unshareState?.rect}
              />
            )}
            <PortalDropdown
              align="end"
              menuItems={[
                {
                  icon: 'bi bi-pencil',
                  label: 'Edit',
                  onClick: () => handleEditTask({ id: taskId, title, description, due_date, category_id, _shared: isShared, _sent: isSent })
                },
                ...(isSent ? [{
                  icon: 'bi bi-share',
                  label: 'Unshare',
                  danger: true,
                  onClick: () => { setUnshareState({ id: taskId, rect: document.querySelector(`[data-item-id="${taskId}"]`)?.getBoundingClientRect() }) },
                }] : []),
                {
                  icon: 'bi bi-check2-square',
                  label: 'Move to Tasks',
                  onClick: () => confirmMoveItem({ id: taskId, title, description, status: isCompleted ? 'completed' : 'pending' }, 'tasks'),
                  disabled: isShared || isSent,
                  title: isShared ? 'No authority' : isSent ? 'Unshare to use' : '',
                },
                {
                  icon: 'bi bi-list-task',
                  label: 'Move to Lists',
                  onClick: () => confirmMoveItem({ id: taskId, title, description, status: isCompleted ? 'completed' : 'pending' }, 'lists'),
                  disabled: isShared || isSent,
                  title: isShared ? 'No authority' : isSent ? 'Unshare to use' : '',
                },
                {
                  icon: 'bi bi-cart3',
                  label: 'Move to Groceries',
                  onClick: () => confirmMoveItem({ id: taskId, title, description, status: isCompleted ? 'completed' : 'pending' }, 'grocery_table'),
                  disabled: isShared || isSent,
                  title: isShared ? 'No authority' : isSent ? 'Unshare to use' : '',
                },
                {
                  icon: 'bi bi-trash',
                  label: 'Remove',
                  danger: true,
                  onClick: () => confirmRemoveTask(taskId),
                  disabled: isShared || isSent,
                  title: isShared ? 'No authority' : isSent ? 'Unshare to use' : '',
                }
              ]}
            >
              <i
                className='bi bi-three-dots-vertical'
                onMouseDown={(e) => e.stopPropagation()}
              ></i>
            </PortalDropdown>
          </div>

          {/* Note Footer Row */}
          <div className="note-card-footer">
            <div className={`task-status-badge ${isCompleted ? 'status-completed' : 'status-pending'}`}>
              <i className={`bi ${isCompleted ? 'bi-check-circle-fill' : 'bi-clock'}`}></i>
              <span>{isCompleted ? 'Completed' : 'Pending'}</span>
            </div>

            {isShared && (
              <div
                title={`Received from ${sharedFrom} — Click to copy email`}
                onClick={(e) => {
                  e.stopPropagation();
                  navigator.clipboard.writeText(sharedFrom);
                }}
                style={{
                  display: 'flex', alignItems: 'center', gap: '3px',
                  fontSize: '0.65rem', color: 'var(--teal-bg)', marginLeft: 'auto',
                  cursor: 'pointer', padding: '1px 6px', borderRadius: '4px',
                  background: 'rgba(var(--teal-bg-rag), 0.08)',
                }}
              >
                <i className="bi bi-box-arrow-in-down-right" style={{ fontSize: '0.7rem' }}></i>
              </div>
            )}

            {isSent && !isShared && (
              <div
                title="Shared to others"
                style={{
                  display: 'flex', alignItems: 'center', gap: '3px',
                  fontSize: '0.65rem', color: '#f59e0b', marginLeft: 'auto',
                  padding: '1px 6px', borderRadius: '4px',
                  background: 'rgba(245, 158, 11, 0.08)',
                }}
              >
                <i className="bi bi-box-arrow-up-right" style={{ fontSize: '0.7rem' }}></i>
              </div>
            )}
          </div>
        </div>
      );
    };
    const formatMessage = (text) => {
      if (!text) return "";
      let cleanedText = text
        .replace(/^"/, "") // Remove leading quotation mark
        .replace(/"$/, "") // Remove trailing quotation mark
        .replace(/\\n/g, ""); // Remove all escaped newlines
      return (
        cleanedText
          .replace(/###\s*(.*?)(?:\n|$)/g, "<h5>$1</h5>") // H3 headings
          .replace(/##\s*(.*?)(?:\n|$)/g, "<h4>$1</h4>") // H2 headings
          .replace(/#\s*(.*?)(?:\n|$)/g, "<h3>$1</h3>") // H1 headings
          .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>") // Bold text
          .replace(
            /(\d+)\.\s+(.*?)(?:\n|$)/g,
            '<ol start="$1"><li>$2</li></ol>'
          ) // Numbered lists
          .replace(
            /`(.*?)`/g,
            '<code style="background-color: #f0f0f0; padding: 2px 4px; border-radius: 4px; font-family: monospace;">$1</code>'
          ) // Inline code
          .replace(
            /\[(.*?)\]\((https?:\/\/[^\s]+)\)/g,
            '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
          )
          .replace(/(^|[^"'>])(https?:\/\/[^\s<]+)/g,
            '$1<a href="$2" target="_blank" rel="noopener noreferrer">$2</a>'
          )
          // .replace(/\n/g, '<br />') // New lines
          .replace(/\{(.*?)\}/g, "$1")
      ); // Remove curly braces
    };
    // Merge own notes + shared notes
    const filteredShared = sharedNotes.filter(st => {
      if (tasks.some(t => t.id === st.id)) return false
      if (!selectedCategory) return true
      if (selectedCategory === '0') return !st.category_id
      if (String(selectedCategory).startsWith('shared_')) {
        const origId = selectedCategory.replace('shared_', '')
        return String(st.category_id) === origId
      }
      return false
    })
    const mergedTasks = [
      ...tasks.map(t => ({ ...t, _sent: sentNoteIds.has(String(t.id)) })),
      ...filteredShared
    ]

    const filteredTasks = mergedTasks.filter(
      (task) =>
        task.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (task.description &&
          task.description.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    useEffect(() => {
      let getUser = async () => {
        const {
          data: { user },
        } = await supabase.auth.getUser();
        if (user) {
          setUserId(user.id);
        }
      };
      getUser();
    }, []);
    // Fetch shared notes when UserId is available
    useEffect(() => {
      if (UserId) { fetchSharedNotes(); fetchSentNoteIds() }
    }, [UserId, fetchSharedNotes, fetchSentNoteIds])

    // Realtime subscription for shared notes
    useEffect(() => {
      if (!UserId) return
      const channel = supabase
        .channel(`shared_notes_${UserId}`)
        .on("postgres_changes", { event: "INSERT", schema: "public", table: "notes", filter: `user_id=eq.${UserId}` }, (payload) => {
          if (payload.new?.is_share) fetchSharedNotes()
        })
        .on("postgres_changes", { event: "UPDATE", schema: "public", table: "notes", filter: `user_id=eq.${UserId}` }, (payload) => {
          if (payload.new?.is_share) fetchSharedNotes()
          else fetchTasks(searchTerm, selectedCategory, selectedSubcategory)
        })
        .on("postgres_changes", { event: "DELETE", schema: "public", table: "notes", filter: `user_id=eq.${UserId}` }, () => fetchSharedNotes())
        .subscribe()
      return () => { supabase.removeChannel(channel) }
    }, [UserId, fetchSharedNotes])

    useEffect(() => {
      fetchCategories();
      fetchTasks(searchTerm, selectedCategory, selectedSubcategory);
    }, [UserId, searchTerm, selectedCategory, selectedSubcategory]);

    const handleTaskCreated = () => {
      fetchTasks(searchTerm, selectedCategory, selectedSubcategory);
      fetchCategories();
      fetchSubcategories(selectedCategory);
    };

    useEffect(() => {
  if (isSidebarVisible) {
    // Reset scroll for all tabs
    if (notesessionScrollRef.current) notesessionScrollRef.current.scrollTop = 0;
  }
      }, [isSidebarVisible]);
    return (
      <>
        <div className="checklist-tabs-header" style={{ padding: '0 1.5em',paddingLeft:"36px", marginBottom: '10px' }}>
          <span style={{ fontWeight: '600', fontSize: '14px' }}>Notes</span>
          <button
            className={`filter-toggle-btn ${showFilters ? 'active' : ''}`}
            onClick={() => setShowFilters(!showFilters)}
            title={showFilters ? 'Hide filters' : 'Show filters'}
          >
            <TbFilterCog size={16} />
          </button>
        </div>
        {showFilters && (
          <>
            <div className="d-flex mb-3 gap-2" style={{ padding: "0em 1.5em" }}>
              <Select
                className="custom-select-container flex-fill"
                classNamePrefix="custom-select"
                options={[
                  { value: "", label: "All Categories" },
                  { value: "0", label: "General" },
                  ...categories.map((category) => ({
                    value: category.id,
                    label: category.name,
                    isSent: sentCategoryIds.has(String(category.id)),
                  })),
                  ...sharedCategories.map(sc => ({
                    value: sc.id,
                    label: sc.name.replace(' (shared)', ''),
                    isShared: true,
                  }))
                ]}
                formatOptionLabel={(option) => (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span>{option.label}</span>
                    {option.isShared && <i className="bi bi-box-arrow-in-down-right" style={{ fontSize: '0.7rem', color: 'var(--teal-bg)' }}></i>}
                    {option.isSent && <i className="bi bi-box-arrow-up-right" style={{ fontSize: '0.7rem', color: '#f59e0b' }}></i>}
                  </div>
                )}
                defaultValue={{ value: "", label: "All Categories" }}
                onChange={(option) =>
                  handleCategoryChange({ target: { value: option?.value || "" } })
                }
                isSearchable={false}
                placeholder="All Categories"
              />
              <Select
                className="custom-select-container flex-fill"
                classNamePrefix="custom-select"
                options={[
                  { value: "", label: "All Subcategories" },
                  ...subcategories.map((subcategory) => ({
                    value: subcategory.id,
                    label: subcategory.name,
                  })),
                ]}
                defaultValue={{ value: "", label: "All Subcategories" }}
                onChange={(option) =>
                  handleSubcategoryChange({ target: { value: option?.value || "" } })
                }
                isSearchable={false}
                isDisabled={!selectedCategory}
                placeholder="All Subcategories"
              />
              {categories && categories.length > 0 ? (
                <button
                  className="delete-category-btn"
                  onClick={() => {
                    setShowDeleteCategory(true);
                  }}
                >
                  <i className="bi bi-trash"></i>
                </button>
              ) : null}
            </div>
            <div className="d-flex mb-3" style={{ padding: "0em 1.5em" }}>
              <Form.Control
                className="search-input-box"
                type="text"
                placeholder="Quick add note..."
                onKeyDown={async (e) => {
                  if (e.key === 'Enter' && e.target.value.trim()) {
                    const title = e.target.value.trim();
                    e.target.value = '';
                    await saveTask({
                      title,
                      description: '',
                      status: 'pending',
                      user_id: UserId
                    });
                    handleTaskCreated();
                  }
                }}
              />
            </div>
            <div className="d-flex mb-3 gap-2" style={{ padding: "0em 1.5em" }}>
              <Form.Control
                className="search-input-box flex-grow-1"
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={handleSearchChange}
              />
              <button
                style={{
                  backgroundColor: "var(--teal-bg)",
                  color: "var(--textwhite)",
                  borderRadius: '8px',
                  height: '38px',
                  width: '38px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                onClick={() => {
                  setShowAddPopup(true);
                }}
              >
                <i className="bi bi-plus"></i>
              </button>
            </div>
          </>
        )}
        <hr />
        {/* render notes list  */}
        <div className="d-flex flex-column">
          <div className="task-list"
           ref={notesessionScrollRef}
          style={{ padding: "0em 1.5em" }}>
            {isLoading ? (
              <div className="wave-loader-container">
                <div className="wave-loader">
                  <div className="wave-bar"></div>
                  <div className="wave-bar"></div>
                  <div className="wave-bar"></div>
                  <div className="wave-bar"></div>
                  <div className="wave-bar"></div>
                </div>
                <span className="wave-loader-text">Loading notes...</span>
              </div>
            ) : filteredTasks.length > 0 ? (
              filteredTasks.map((task) =>
                renderTask(
                  task.id,
                  task.title,
                  task.description,
                  task.due_date,
                  task.category_id,
                  task._shared || false,
                  task._sharedFrom || '',
                  task._isNew || false,
                  task._sent || false
                )
              )
            ) : (
              <div className="text-center">No data found</div>
            )}
          </div>
          {(groupedTasks.today.length > 0 ||
            groupedTasks.next7Days.length > 0 ||
            groupedTasks.next30Days.length > 0 ||
            groupedTasks.later.length > 0 ||
            hasMoreTasks) && (
            <div className="d-flex justify-content-center mt-3">
              {(groupedTasks.today.length > 0 ||
                groupedTasks.next7Days.length > 0 ||
                groupedTasks.next30Days.length > 0 ||
                groupedTasks.later.length > 0) && (
                <span
                  style={{ cursor: "pointer", marginRight: "15px" }}
                  onClick={handleExpandAll}
                >
                  Expand
                </span>
              )}
              {hasMoreTasks && (
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    fetchAllTasks(searchTerm, selectedCategory);
                    setShowExportMore(true);
                  }}
                >
                  Show All
                </span>
              )}
            </div>
          )}
        </div>

        <ConfirmationPopup
          show={showConfirmation}
          handleClose={() => setShowConfirmation(false)}
          title="Confirm Removal"
          body="Are you sure you want to remove this note? This action cannot be undone."
          handleConfirm={removeTask}
        />
        <ConfirmationPopup
          show={showMoveConfirmation}
          handleClose={() => {
            setShowMoveConfirmation(false);
            setItemToMove(null);
            setMoveTarget(null);
          }}
          title={`Move to ${getMoveTargetLabel(moveTarget)}`}
          body={`Are you sure you want to move "${itemToMove?.title}" to ${getMoveTargetLabel(moveTarget)}? The item will be removed from Notes.`}
          handleConfirm={moveItem}
        />

        <EditPopup
          show={showEditPopup}
          handleClose={() => setShowEditPopup(false)}
          handleSave={saveTask}
          item={taskToEdit}
          categoriesData={categories}
          fetchSubcategories={fetchSubcategories}
          subcategoriesData={subcategories}
          sharedCategories={sharedCategories}
          titleAction="Notes"
          handleDelete={confirmRemoveTask}
        />
        {UserId && showExportMore === true && (
          <NotesExpandMoreopup
            isDarkMode={isDarkMode}
            show={showExportMore}
            handleClose={() => setShowExportMore(false)}
            title="Notes"
            category={selectedCategory}
            subcategory={selectedSubcategory}
            search={searchTerm}
            UserId={UserId}
            isNotesCategoryUpdate={isNotesCategoryUpdate}
            isNotesDataChannelUpdate={isNotesDataChannelUpdate}
          />
        )}

        {UserId && showExpandAll === true && (
          <NotesExpandAllPopup
            isDarkMode={isDarkMode}
            show={showExpandAll}
            handleClose={() => setShowExpandAll(false)}
            title="Notes"
            category={selectedCategory}
            subcategory={selectedSubcategory}
            search={searchTerm}
            // items={allTasks}
            // fetchItems={fetchAllTasks}
            UserId={UserId}
            isNotesCategoryUpdate={isNotesCategoryUpdate}
            isNotesDataChannelUpdate={isNotesDataChannelUpdate}
          />
        )}
        {UserId && (
          <AddTaskPopUp
            actionTitle={"Add Note"}
            show={showAddPopup}
            handleClose={() => setShowAddPopup(false)}
            handleSave={saveTask}
            categoriesData={categories}
            fetchSubcategories={fetchSubcategories}
            subcategoriesData={subcategories}
            UserId={UserId}
            onTaskCreated={handleTaskCreated}
          />
        )}
        {categories?.length ? (
          <DeleteCategoryPopUp
            show={ShowDeleteCategory}
            categpries={categories}
            handleClose={() => setShowDeleteCategory(false)}
            type="notes"
            onCategoryDeleted={() => fetchCategories()}
          ></DeleteCategoryPopUp>
        ) : null}
      </>
    );
  }
);

export default NotesList;
